export default __webpack_public_path__ + "static/media/0047.979995bf.png";